import { rmsSupportCenterTypes } from '../reduxExports';

const rmsSupportCenterInitialState: RmsSupportCenterState = {
    rmsSupportSearchQueryMatchingPrompts:null,
    rmsSupportSearchQueryMatchingPromptsSearchHash:null,
    rmsSupportSearchQueryResponse:[],
    rmsSupportSearchQueryResponseSearchHash: null,
    rmsSupportSearchQueryResponseLoader:false,
    rmsSupportSearchQuery:null,
    rmsSupportTroubleshootingAlarmTableProps: {
        view: 'list',
        sortBy: 'alarm',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    rmsSupportTroubleshootingAlarmList:null,
    rmsSupportTroubleshootingAlarmListCount: 0,
    rmsSupportTroubleshootingListLoader: false,
    rmsSupportTroubleshootingSearchHash: null,
    rmsSupportTroubleshootingFilterHash: null,
    rmsSupportTroubleshootingStopReasonTableProps: {
        view: 'list',
        sortBy: 'stopReason',
        order: 'ascending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    rmsSupportTroubleshootingStopReasonList: null,
    rmsSupportTroubleshootingStopReasonListCount: 0,
    rmsSupportDocumentationTableProps: {
        view: 'list',
        sortBy: 'updatedAt',
        order: 'descending',
        pageSize: 15,
        pageNumber: 1,
        searchTerm: null
    },
    rmsSupportDocumentationList: null,
    rmsSupportDocumentationListCount: 0,
    rmsSupportDocumentationSearchHash: null,
    rmsSupportDocumentationFilterHash: null,
    rmsSupportDocumentationListLoader: false,
}


const rmsSupportCenterReducer = (
    state: RmsSupportCenterState = rmsSupportCenterInitialState,
    action: RmsSupportCenterAction
): RmsSupportCenterState => {
    switch(action.type){
        case rmsSupportCenterTypes.FETCH_RMS_SUPPORT_AI_CHATBOT_SEARCH_QUERY_MATCHING_PROMPTS:
            return {
                ...state,
                rmsSupportSearchQueryMatchingPrompts: action.rmsSupportSearchQueryMatchingPrompts
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_MATCHING_PROMPTS_SEARCH_HASH:
            return {
                ...state,
                rmsSupportSearchQueryMatchingPromptsSearchHash: action.rmsSupportSearchQueryMatchingPromptsSearchHash
            }
        case rmsSupportCenterTypes.FETCH_RMS_SUPPORT_SEARCH_QUERY_RESPONSE:
            return {
                ...state,
                rmsSupportSearchQueryResponse:[...state.rmsSupportSearchQueryResponse,...action.rmsSupportSearchQueryResponse]
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_RESPONSE_SEARCH_HASH:
            return{
                ...state,
                rmsSupportSearchQueryResponseSearchHash:action.rmsSupportSearchQueryResponseSearchHash
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_SEARCH_QUERY_RESPONSE_LOADER:
            return {
                ...state,
                rmsSupportSearchQueryResponseLoader:action.rmsSupportSearchQueryResponseLoader,
                rmsSupportSearchQuery: action.rmsSupportSearchQuery
            }
        case rmsSupportCenterTypes.CLEAR_RMS_SUPPORT_SEARCH_QUERY_RESPONSE:
            return {
                ...state,
                rmsSupportSearchQueryResponse:[],
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_ALARM_TABLE_PROPS:
            return {
            ...state,
            rmsSupportTroubleshootingAlarmTableProps: action.rmsSupportTroubleshootingAlarmTableProps || state.rmsSupportTroubleshootingAlarmTableProps
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_STOP_REASON_TABLE_PROPS:
            return {
            ...state,
            rmsSupportTroubleshootingStopReasonTableProps: action.rmsSupportTroubleshootingStopReasonTableProps || state.rmsSupportTroubleshootingStopReasonTableProps
            }
        case rmsSupportCenterTypes.FETCH_RMS_SUPPORT_TROUBLESHOOTING_ALARM_LIST:
            return {
            ...state,
            rmsSupportTroubleshootingAlarmList: action.rmsSupportTroubleshootingAlarmList,
            rmsSupportTroubleshootingAlarmListCount: action.rmsSupportTroubleshootingAlarmListCount
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_LIST_LOADER:
            return {
                ...state,
                rmsSupportTroubleshootingListLoader: action.rmsSupportTroubleshootingListLoader || false
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_TROUBLESHOOTING_LIST_REQUEST_HASH:
            return {
                ...state,
                rmsSupportTroubleshootingSearchHash: action.rmsSupportTroubleshootingSearchHash,
                rmsSupportTroubleshootingFilterHash: action.rmsSupportTroubleshootingFilterHash
            }
        case rmsSupportCenterTypes.FETCH_RMS_SUPPORT_TROUBLESHOOTING_STOP_REASON_LIST:
            return {
                ...state,
                rmsSupportTroubleshootingStopReasonList: action.rmsSupportTroubleshootingStopReasonList,
                rmsSupportTroubleshootingStopReasonListCount: action.rmsSupportTroubleshootingStopReasonListCount
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_LIST_LOADER:
            return {
                ...state,
                rmsSupportDocumentationListLoader: action.rmsSupportDocumentationListLoader || false
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_LIST_REQUEST_HASH:
            return {
                ...state,
                rmsSupportDocumentationSearchHash: action.rmsSupportDocumentationSearchHash,
                rmsSupportDocumentationFilterHash: action.rmsSupportDocumentationFilterHash
            }
        case rmsSupportCenterTypes.SET_RMS_SUPPORT_DOCUMENTATION_TABLE_PROPS:
            return {
                ...state,
                rmsSupportDocumentationTableProps: action.rmsSupportDocumentationTableProps || state.rmsSupportDocumentationTableProps
            }
        case rmsSupportCenterTypes.FETCH_RMS_SUPPORT_DOCUMENTATION_LIST:
            return {
                ...state,
                rmsSupportDocumentationList: action.rmsSupportDocumentationList,
                rmsSupportDocumentationListCount: action.rmsSupportDocumentationListCount,
            }
        default:
            return state;
    }
}

export default rmsSupportCenterReducer;